import { PQR_TYPE_EDIT } from '../../../../../../routes/paths';
import { MouseEventHandler } from 'react';

export const usePqrTypeListActions = (id: string) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${PQR_TYPE_EDIT}/${id}`, '_blank');
    };

    return {
        handleEdit,
    };
};
